<div class="rd-widget rd-widget-no-height-restriction widget-{{widgetConfig.widgetId}}" *ngIf="widgetData">
  <table class="widget-large cellspacing-0 cellpadding-0" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-large">
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>

        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>

        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>

        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <tr class="red-line">
        <ng-container *ngIf="editMode">
          <td colspan="1">
            <span class="k-icon k-i-minus" (click)="deleteCurrentRow()"></span>
          </td>
          <td colspan="1">
            <span class="k-icon k-i-plus" (click)="addRow()" *ngIf="sectionHasAvailableFields('franceEsgExteriorDescription')"></span>
          </td>
          <td colspan="1">
            <span class="k-icon k-i-arrow-up" (click)="moveCurrentRowUp()"></span>
          </td>
          <td colspan="1">
            <span class="k-icon k-i-arrow-down" (click)="moveCurrentRowDown()"></span>
          </td>
        </ng-container>
        <td [attr.colspan]="(editMode?29:33)"><widget-value [align]="'left'" [color]="'white'" [bold]="true">{{'franceEsgExteriorDescription.labelTitle' | rdTranslate}}</widget-value></td>
      </tr>
      <rd-textandlist-section [widget]="this" [page]="page" [sectionName]="textAndListSectionName" [reflists]="reflists" [topicReflist]="'ref_l3_esg_exterior_description_france_topics'" [editMode]="editMode" [rows]="rows" [leftColspan]="17" [rightColspan]="16" [data]="widgetData" [alternatingColorScheme]="true" [currency]="currency" [unitOfArea]="unitOfArea" [addRow]="addRow$" [deleteCurrentRow]="deleteCurrentRow$" [moveCurrentRowUp]="moveCurrentRowUp$" [moveCurrentRowDown]="moveCurrentRowDown$" (sectionRowsCountChanged)="sectionRowsCountChanged($event)">
        <table class="lettable-area-table cellspacing-0 cellpadding-0" aria-hidden="true">
          <thead>
            <tr>
              <th scope="col">{{'franceEsgExteriorDescription.labelArea' | rdTranslate}}</th>
              <th scope="col">{{'franceEsgExteriorDescription.labelFloor' | rdTranslate}}</th>
              <th scope="col">{{unitOfArea}}</th>
              <th scope="col">{{'franceEsgExteriorDescription.labelTenant' | rdTranslate}}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of widgetData['lettableArea']; let i = index;">
              <tr>
                <td>
                  <widget-value [align]="'right'">{{widgetData['lettableArea'][i].usage}}</widget-value>
                </td>
                <td>
                  <widget-value [align]="'right'">{{widgetData['lettableArea'][i].floor}}</widget-value>
                </td>
                <td>
                  <widget-value [align]="'right'">{{widgetData['lettableArea'][i].size | rdLocalizedNumber:0}} {{unitOfArea}}</widget-value>
                </td>
                <td>
                  <widget-value [align]="'right'">{{widgetData['lettableArea'][i].tenant}}</widget-value>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </rd-textandlist-section>
    </tbody>
  </table>
</div>
